// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.4.5_@swc+helpers@0.5.15__webpack@5.98.0_@swc+core@1.11.24_@sw_wm7ee5ic4mofrhisudwon4qpq4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.4.5_@swc+helpers@0.5.15__webpack@5.98.0_@swc+core@1.11.24_@sw_wm7ee5ic4mofrhisudwon4qpq4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tooltip-wrapper {
  position: relative;
  display: inline-block;
  line-height: 1;
}

.tooltip {
  position: relative;
  padding: 6px 12px;
  border-radius: 8px;
  font-size: 14px;
  line-height: 1.4;
  pointer-events: none;
}

.tooltip-arrow {
  position: absolute;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: var(--arrow-size, 6px);
  border-color: transparent;
}

.tooltip-arrow--top {
  border-width: var(--arrow-size, 6px) var(--arrow-size, 6px) 0
    var(--arrow-size, 6px);
  border-top-color: var(--tooltip-bg-color);
  bottom: 0;
  transform: translateY(100%);
}

.tooltip-arrow--bottom {
  border-width: 0 var(--arrow-size, 6px) var(--arrow-size, 6px)
    var(--arrow-size, 6px);
  border-bottom-color: var(--tooltip-bg-color);
  top: 0;
  transform: translateY(-100%);
}

.tooltip-arrow--left {
  border-width: var(--arrow-size, 6px) 0 var(--arrow-size, 6px)
    var(--arrow-size, 6px);
  border-left-color: var(--tooltip-bg-color);
  right: 0;
  transform: translateX(100%);
}

.tooltip-arrow--right {
  border-width: var(--arrow-size, 6px) var(--arrow-size, 6px)
    var(--arrow-size, 6px) 0;
  border-right-color: var(--tooltip-bg-color);
  left: 0;
  transform: translateX(-100%);
}

.tooltip-positioner {
  z-index: var(--top-z-index);
}
`, "",{"version":3,"sources":["webpack://./src/next-devtools/components/tooltip.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,mBAAmB;EACnB,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE;0BACwB;EACxB,yCAAyC;EACzC,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE;0BACwB;EACxB,4CAA4C;EAC5C,MAAM;EACN,4BAA4B;AAC9B;;AAEA;EACE;0BACwB;EACxB,0CAA0C;EAC1C,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE;4BAC0B;EAC1B,2CAA2C;EAC3C,OAAO;EACP,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;AAC7B","sourcesContent":[".tooltip-wrapper {\n  position: relative;\n  display: inline-block;\n  line-height: 1;\n}\n\n.tooltip {\n  position: relative;\n  padding: 6px 12px;\n  border-radius: 8px;\n  font-size: 14px;\n  line-height: 1.4;\n  pointer-events: none;\n}\n\n.tooltip-arrow {\n  position: absolute;\n  width: 0;\n  height: 0;\n  border-style: solid;\n  border-width: var(--arrow-size, 6px);\n  border-color: transparent;\n}\n\n.tooltip-arrow--top {\n  border-width: var(--arrow-size, 6px) var(--arrow-size, 6px) 0\n    var(--arrow-size, 6px);\n  border-top-color: var(--tooltip-bg-color);\n  bottom: 0;\n  transform: translateY(100%);\n}\n\n.tooltip-arrow--bottom {\n  border-width: 0 var(--arrow-size, 6px) var(--arrow-size, 6px)\n    var(--arrow-size, 6px);\n  border-bottom-color: var(--tooltip-bg-color);\n  top: 0;\n  transform: translateY(-100%);\n}\n\n.tooltip-arrow--left {\n  border-width: var(--arrow-size, 6px) 0 var(--arrow-size, 6px)\n    var(--arrow-size, 6px);\n  border-left-color: var(--tooltip-bg-color);\n  right: 0;\n  transform: translateX(100%);\n}\n\n.tooltip-arrow--right {\n  border-width: var(--arrow-size, 6px) var(--arrow-size, 6px)\n    var(--arrow-size, 6px) 0;\n  border-right-color: var(--tooltip-bg-color);\n  left: 0;\n  transform: translateX(-100%);\n}\n\n.tooltip-positioner {\n  z-index: var(--top-z-index);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
